"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _fullscreenProviderLicense = _interopRequireDefault(require("./fullscreenProviderLicense.js"));
var _fullscreenCartButton = _interopRequireDefault(require("./fullscreenCartButton.js"));
var _fullscreenCheckoutLink = _interopRequireDefault(require("./fullscreenCheckoutLink.js"));
var _ProductsList = _interopRequireDefault(require("./ProductsList.js"));
var _mobileViewTypes = _interopRequireDefault(require("wix-art-store-3rd-party/dist/src/sdk/mobileViewTypes"));
var _utils = require("../utils");
var _lodash = _interopRequireDefault(require("lodash"));
var storeComponentPosition = {
  top: 1,
  bottom: 2
};
var FullscreenStoreBottomMobileBar = /*#__PURE__*/function (_React$Component) {
  function FullscreenStoreBottomMobileBar(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {};
    return _this;
  }
  (0, _inheritsLoose2["default"])(FullscreenStoreBottomMobileBar, _React$Component);
  var _proto = FullscreenStoreBottomMobileBar.prototype;
  _proto.handleProviderAction = function handleProviderAction(type, data) {
    if (this.props.onProviderAction) {
      this.props.onProviderAction(type, data);
    }
  };
  _proto.getStoreComponent = function getStoreComponent(_ref) {
    var _this2 = this;
    var type = _ref.type,
      data = _ref.data;
    var storeComponentData = {
      component: null,
      position: storeComponentPosition.top
    };
    switch (type) {
      case _mobileViewTypes["default"].singleProduct:
        storeComponentData.component = /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_fullscreenProviderLicense["default"], {
          actions: this.props.actions,
          pricingData: data
        }), /*#__PURE__*/_react["default"].createElement(_fullscreenCartButton["default"], {
          cartItems: this.props.cartItems,
          onAddToCartRequest: function onAddToCartRequest() {
            return _this2.props.onAddToCartRequest();
          },
          styleParams: this.props.styleParams
        }));
        break;
      case _mobileViewTypes["default"].productsList:
        storeComponentData.position = storeComponentPosition.bottom;
        storeComponentData.component = /*#__PURE__*/_react["default"].createElement(_ProductsList["default"], {
          data: data,
          onProviderAction: function onProviderAction(type, data) {
            return _this2.handleProviderAction(type, data);
          }
        });
        break;
      default:
        storeComponentData.component = /*#__PURE__*/_react["default"].createElement("div", {
          className: "store-preload"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "pro-circle-preloader",
          ref: function ref(_ref2) {
            return _this2.loader = _ref2;
          }
        }));
        break;
    }
    return storeComponentData;
  };
  _proto.render = function render() {
    var _this3 = this;
    var curItem = _lodash["default"].get(this.props, 'item') || _lodash["default"].get(this.props, 'current.item');
    var isImage = curItem.type === ('image' || 'picture');
    var _this$props = this.props,
      providerView = _this$props.providerView,
      freeArtStore = _this$props.freeArtStore;
    if (!providerView && !freeArtStore) {
      return null;
    }
    var selectedLicense = null,
      shopButtons = null;
    if (isImage && !freeArtStore) {
      selectedLicense = this.getStoreComponent(providerView);
      shopButtons = /*#__PURE__*/_react["default"].createElement(_fullscreenCheckoutLink["default"], {
        cartItemsCount: this.props.cartItemsCount,
        onClick: function onClick() {
          return _this3.props.onClick();
        }
      });
    }
    var titleText = _utils.utils.getTitleOrFilename(curItem.title, curItem.fileName) || ''; // (curItem.isDemo ? curItem.demoTitle : ''); - remove default text from demo items until rewritten
    var title = titleText && this.props.styleParams.allowTitleExpand ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "fullscreen-side-bar-title"
    }, titleText) : '';
    var descriptionText = curItem.description || ''; // (curItem.isDemo ? curItem.demoDescription : ''); - remove default text from demo items until rewritten
    var descriptionTextArray = descriptionText.split('\n');
    var description;
    if (descriptionText && this.props.styleParams.allowDescriptionExpand) {
      var descriptionElementsArray = [];
      for (var i = 0; i < descriptionTextArray.length; i++) {
        descriptionElementsArray.push(/*#__PURE__*/_react["default"].createElement("div", {
          className: "fullscreen-side-bar-description-line",
          key: 'description_' + i
        }, descriptionTextArray[i]));
      }
      description = /*#__PURE__*/_react["default"].createElement("div", {
        className: "fullscreen-side-bar-description"
      }, descriptionElementsArray);
    } else {
      description = '';
    }
    var linkClassNames = 'fullscreen-side-bar-link pro-fullscreen-link pro-fullscreen-store';
    var link = curItem.hasLink && this.props.styleParams.allowLinkExpand ? curItem.linkType === 'web' ? /*#__PURE__*/_react["default"].createElement("a", {
      className: linkClassNames,
      href: !curItem.isWixUrl && curItem.linkUrl,
      onClick: function onClick() {
        return curItem.isWixUrl && _this3.props.actions.onLinkNavigation(curItem);
      },
      target: curItem.linkOpenType
    }, curItem.linkText || curItem.linkUrl) : /*#__PURE__*/_react["default"].createElement("div", {
      className: linkClassNames,
      onClick: function onClick() {
        return _this3.props.actions.onLinkNavigation(curItem);
      }
    }, curItem.linkText || curItem.linkUrl) : '';
    var shouldRenderSelectedLicenseOnTop = selectedLicense && selectedLicense.position === storeComponentPosition.top;
    var shouldRenderSelectedLicenseOnBottom = selectedLicense && selectedLicense.position === storeComponentPosition.bottom;
    var ShopElement = selectedLicense && [selectedLicense.component, shopButtons];
    var infoElement = /*#__PURE__*/_react["default"].createElement("div", {
      className: "fullscreen-side-bar-info-container pro-fullscreen-store"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      ref: function ref(itemContainer) {
        _this3.itemContainer = itemContainer;
      }
    }, title, description), link);
    var fullscreenMobileInfoElement = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
    if (typeof this.props.customShopWrapper === 'function') {
      fullscreenMobileInfoElement = this.props.customShopWrapper({
        ShopElement: ShopElement,
        infoElement: infoElement,
        curItem: curItem
      });
    } else {
      fullscreenMobileInfoElement = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, shouldRenderSelectedLicenseOnTop && ShopElement, infoElement, shouldRenderSelectedLicenseOnBottom && ShopElement);
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "fullscreen-bottom-mobile-info pro-fullscreen-store",
      style: {
        textAlign: this.props.styleParams.galleryAlignExpand,
        height: '100%'
      }
    }, fullscreenMobileInfoElement);
  };
  return FullscreenStoreBottomMobileBar;
}(_react["default"].Component);
var _default = exports["default"] = FullscreenStoreBottomMobileBar;